import { Component, Input, OnInit, HostListener } from '@angular/core';
import { AppSettingService } from 'src/services/app-setting/app-setting.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  isMobileMenuOpen = false;
  activeDropdown: string | null = null;

  constructor(public appSettingService: AppSettingService) { }

  ngOnInit() {
    console.log('NavbarComponent initialized');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown')) {
      this.activeDropdown = null;
      console.log('Dropdown closed by outside click');
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    console.log('Mobile menu toggled:', this.isMobileMenuOpen);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    console.log('Mobile menu closed');
  }

  toggleDropdown(dropdownName: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    console.log('Toggle dropdown:', dropdownName, 'Current active:', this.activeDropdown);
    
    if (this.activeDropdown === dropdownName) {
      this.activeDropdown = null;
      console.log('Dropdown closed:', dropdownName);
    } else {
      this.activeDropdown = dropdownName;
      console.log('Dropdown opened:', dropdownName);
    }
  }

  isDropdownActive(dropdownName: string): boolean {
    const isActive = this.activeDropdown === dropdownName;
    console.log('Check dropdown active:', dropdownName, 'Result:', isActive);
    return isActive;
  }
}
